import { render, staticRenderFns } from "./inputsTable.vue?vue&type=template&id=15d63ee0&"
import script from "./inputsTable.vue?vue&type=script&lang=js&"
export * from "./inputsTable.vue?vue&type=script&lang=js&"
import style0 from "./inputsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports